import { render, staticRenderFns } from "./alerts.my-payments.vue?vue&type=template&id=47a2b48b&"
import script from "./alerts.my-payments.vue?vue&type=script&lang=js&"
export * from "./alerts.my-payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports